import { useTheme } from "@/components/theme-provider";
import { useEffect, useState } from "react";

export function ThemeToggle({ className = "" }: { className?: string }) {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div
        className={`h-9 min-w-[7.25rem] shrink-0 rounded-lg border border-border bg-topbar ${className}`}
        aria-hidden
      />
    );
  }

  const effective =
    theme === "system" ? `System (${resolvedTheme ?? "…"})` : theme;

  return (
    <div
      className={`flex max-w-full shrink-0 flex-nowrap items-center rounded-lg border border-border bg-topbar p-0.5 shadow-sm ${className}`}
      role="group"
      aria-label="Theme"
    >
      {(
        [
          { id: "light" as const, label: "Light" },
          { id: "dark" as const, label: "Dark" },
          { id: "system" as const, label: "Auto" },
        ] as const
      ).map(({ id, label }) => (
        <button
          key={id}
          type="button"
          onClick={() => setTheme(id)}
          title={id === "system" ? "Match device appearance" : `${label} theme`}
          className={`whitespace-nowrap rounded-md px-1.5 py-1.5 text-[11px] font-medium transition sm:px-2.5 sm:text-xs ${
            theme === id
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-muted hover:bg-hover-subtle hover:text-foreground"
          }`}
        >
          {label}
        </button>
      ))}
      <span className="sr-only">Current: {effective}</span>
    </div>
  );
}
